import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'
import {RefundReservationReasonTransactionsRequest} from '../Requests/RefundReservationReasonTransactionsRequest.js'

/**
 * @implements UseCase
 */

class RefundReservationTransactionsUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()

    this.#repository = repository
  }

  static create({config}) {
    return new RefundReservationTransactionsUseCase({repository: HTTPTransactionRepository.create({config})})
  }

  @tracer({metric: 'RefundReservationTransactionsUseCase#execute'})
  @AsyncInlineError()
  async execute({reservationId, refundRequest}) {
    const reservationIdVO = StringSharedValueObject.create({value: reservationId})
    const {reason, opinion} = refundRequest

    const refundRequestVO = RefundReservationReasonTransactionsRequest.create({reason, opinion})

    const [error, response] = await this.#repository.refundReservation({
      refundRequestVO,
      reservationIdVO
    })

    if (error) throw error

    return response
  }
}

export const factory = RefundReservationTransactionsUseCase.create
